import styled from 'styled-components'

const LanguageStyled = styled.div`
  display: flex;
  gap: .5rem;
  align-items: center;
  font: var(--caption-regular);
  &::before{
    content: '';
    inline-size: 1rem;
    block-size: 1rem;
    border-radius: 50%;
    background-color: ${({ color }) => color};
  }
`;

const languages = {
  html: {
    color: "red",
  },
  css: {
    color: "green",
  },
  javascript: {
    color: "yellow",
  },
  ruby: {
    color: "purple",
  },
  java: {
    color: "orange",
  },
};

function Language({name}) {
  const formattedName = name.toLowerCase()
  const color = languages[formattedName] ? languages[formattedName].color : 'white'
  return (
    <LanguageStyled color={color}>
      {name}
    </LanguageStyled>
  )
}

export default Language
